<div class="bb-stack border-bottom-selector beneficiary-selector-ui__beneficiary-contact">
  <div class="d-none d-md-block bb-stack__item">
    <span class="sr-only"
      i18n="@@beneficiary.selector.ui.group.contacts">Contact</span>
  </div>

  <div class="text-left">
    <span class="sr-only"
      i18n="@@beneficiary.selector.ui.contact.account.name.label"
      id="contact_accountNameLabel">
      Account name:
    </span>
    <div *ngIf="contact?.accounts[0]?.accountType !== 'SERVICES'"
      class="bb-text-bold"
      data-role="beneficiary-account-name-list-item">
      {{ contact?.alias || contact?.name }}
      <ng-container *ngIf="contact?.accounts[0].alias || contact?.accounts[0].name">
        - {{ contact?.accounts[0]?.alias || contact?.accounts[0]?.name }}
      </ng-container>
    </div>

    <div *ngIf="contact?.accounts[0]?.accountType === 'SERVICES'">
      <div *ngIf="contact?.accounts[0]?.additions?.billerName"
        class="bb-text-bold">
        {{ contact?.accounts[0]?.additions?.billerName}}
      </div>
      <span *ngIf="contact?.accounts[0]?.alias">
        {{ contact?.accounts[0]?.alias }} -
      </span>
      {{ contact?.accounts[0]?.additions?.contractNumber }}
    </div>

    <span class="sr-only"
      i18n="@@beneficiary.selector.ui.contact.account.number.label"
      id="contact_accountNumberLabel">
      ; Account number:
    </span>
    <div class="text-dark"
      *ngIf="accountNumber && contact?.accounts[0]?.accountType !== 'SERVICES'"
      data-role="beneficiary-account-number-list-item">
      <ng-container *ngIf="displayBankName && contact?.accounts[0]?.accountType !== 'BANESCO'"> {{
        contact?.accounts[0].bankName }} - </ng-container> {{ accountNumber }}
      <ng-container *ngIf="contact?.accounts[0]?.accountType === 'BANESCO'">
        - Banesco Banco Múltiple
      </ng-container>
    </div>

  </div>
</div>
